// extracted by mini-css-extract-plugin
module.exports = {"note":"_3efo4_","title":"_3YtpnO","steps":"_2n_L8H","buttonPlaceholder":"_4QWj78","orderButton":"_1BkQWm"};